import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { ContactFormFields, CurrentStatus, WidgetSettings } from './model';
import { getOneChatSettings } from './oneChatSettingsThunks';

export type OneChatSettingsState = {
  value: WidgetSettings | null;
  defaultAvatar?: string;
  currentStatus: CurrentStatus | null;
  request: 'idle' | 'loading' | 'error';
  currentRequestId?: string;
};

const initialState: OneChatSettingsState = {
  value: null,
  defaultAvatar: undefined,
  currentStatus: null,
  request: 'idle',
  currentRequestId: undefined,
};

export const oneChatSettingsSlice = createSlice({
  name: 'oneChatSettings',
  initialState,
  reducers: {
    set: (
      state,
      {
        payload,
      }: PayloadAction<
        { settings: WidgetSettings } & {
          defaultAvatar?: string;
          currentStatus: CurrentStatus | null;
        }
      >,
    ) => {
      state.value = payload.settings;
      state.defaultAvatar = payload.defaultAvatar;
      state.currentStatus = payload.currentStatus;
    },
    setContactForm: (state, { payload }: PayloadAction<ContactFormFields>) => {
      if (state.value) {
        state.value.commonBehavior!.contactForm!.fields = {
          ...state.value.commonBehavior!.contactForm!.fields,
          ...payload,
        };
      }
    },
    setCurrentStatus: (
      state,
      { payload }: PayloadAction<CurrentStatus | null>,
    ) => {
      state.currentStatus = payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getOneChatSettings.pending, (state, action) => {
      state.currentRequestId = action.meta.requestId;
      state.request = 'loading';
    });
    builder.addCase(getOneChatSettings.fulfilled, (state, action) => {
      if (state.currentRequestId === action.meta.requestId) {
        state.request = 'idle';
        state.currentRequestId = undefined;
      }
    });
    builder.addCase(getOneChatSettings.rejected, (state, action) => {
      if (state.currentRequestId === action.meta.requestId) {
        state.request = 'error';
        state.currentRequestId = undefined;
      }
    });
  },
});

export const { reducer: oneChatSettingsReducer } = oneChatSettingsSlice;
